import { createSlice } from '@reduxjs/toolkit';
import actions from './actions';
import { NAME_REDUCER } from './constants';
import { IState } from './types/reducer';

const initialState: IState = {
  list: [],
  detail: null,
  categoryList: [],
  listByCategory: null,
};

export const Slice = createSlice({
  name: NAME_REDUCER,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(actions.getGiftCardDetail.success, (state, { payload }) => {
        state.detail = payload;
      })
      .addCase(actions.getGiftCardToBuy.success, (state, { payload }) => {
        state.list = payload;
      })
      .addCase(actions.getListCategoryGiftCard.success, (state, { payload }) => {
        state.categoryList = payload;
      })
      .addCase(actions.getListGiftCardByCategory.success, (state, { payload }) => {
        state.listByCategory = payload;
      });
  },
});

const giftCardServiceReducer = Slice.reducer;
export default giftCardServiceReducer;
